export default "__VITE_ASSET__C32asXWW__"